import { STATIC_DATA_URL } from '../constants';

export const GEOGRAPHY_DATA_URL = `${STATIC_DATA_URL}/geography`;
